<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Conclusão da Marcação</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioInformacaoFechamento" (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-8 col-12">
                            <mat-label>Funcionário Conslusão</mat-label>
                            <input matInput value="Funcionário Conslusão" class="form-control" id="loginUserFechamento"
                                name="loginUserFechamento" formControlName="loginUserFechamento" 
                                style="text-transform: uppercase;">
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                            <mat-label>Data Conclusão</mat-label>
                            <input matInput value="Data Conclusão" class="form-control" id="dataFechamentoFormatada"
                                name="dataFechamentoFormatada" formControlName="dataFechamentoFormatada">
                        </mat-form-field>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes">
                            <button type="button" mat-mini-fab color="primary" (click)="gotoList()" matTooltip="Voltar">
                                <mat-icon>west</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>